import { useEffect } from 'react';

const DEFAULT_TITLE = 'Atölye Kirpi | Özgün Tablolar & Sanat Eserleri';
const DEFAULT_DESC = 'Özgün el yapımı tablolar ve sanat eserleri. Yağlı boya, akrilik, kanvas baskı ve dekoratif tablolar. Hızlı kargo, güvenli alışveriş.';

export default function useSeo({ title, description, keywords, canonical } = {}) {
    useEffect(() => {
        // Title
        document.title = title || DEFAULT_TITLE;

        // Description
        let metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) metaDesc.setAttribute('content', description || DEFAULT_DESC);

        // Keywords
        let metaKeywords = document.querySelector('meta[name="keywords"]');
        if (metaKeywords && keywords) metaKeywords.setAttribute('content', keywords);

        // OG tags
        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) ogTitle.setAttribute('content', title || DEFAULT_TITLE);
        const ogDesc = document.querySelector('meta[property="og:description"]');
        if (ogDesc) ogDesc.setAttribute('content', description || DEFAULT_DESC);

        // Canonical
        let link = document.querySelector('link[rel="canonical"]');
        if (link && canonical) link.setAttribute('href', canonical);

        return () => {
            document.title = DEFAULT_TITLE;
            if (metaDesc) metaDesc.setAttribute('content', DEFAULT_DESC);
        };
    }, [title, description, keywords, canonical]);
}
